import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { useToast } from '@/ui';
import { Icon } from '@/icons';
import type { MoreLink } from '@/core/models/more';
import { MoreIcon } from './MoreIcon';

const rowBase = css`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 10px 12px;
  border-radius: ${({ theme }) => theme.radius.md};
  text-align: left;
  background: transparent;
  border: none;
  cursor: pointer;
  color: ${({ theme }) => theme.color.textMuted};
  text-decoration: none;
  &:hover { background: ${({ theme }) => theme.color.hover}; color: ${({ theme }) => theme.color.textPrimary}; }
  &:focus-visible { outline: 2px solid ${({ theme }) => theme.color.focusRing}; outline-offset: -2px; }
`;
const RowLink = styled(Link)<{ $primary?: boolean }>`
  ${rowBase}
  ${({ $primary, theme }) => $primary && css`color: ${theme.color.textPrimary}; background: ${theme.color.glassBorder};`}
`;
const RowButton = styled.button` ${rowBase} `;
const Lead = styled.span` display: inline-flex; flex: 0 0 auto; color: ${({ theme }) => theme.color.textPrimary}; `;
const Text = styled.span` flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 2px; `;
const Label = styled.span` color: ${({ theme }) => theme.color.textPrimary}; font-size: ${({ theme }) => theme.fontSize.sm}; font-weight: 600; `;
const Sub = styled.span` font-size: ${({ theme }) => theme.fontSize.xs}; color: ${({ theme }) => theme.color.textMuted}; `;
const SoonTag = styled.span` font-size: ${({ theme }) => theme.fontSize.xs}; color: ${({ theme }) => theme.color.textMuted}; border: 1px solid ${({ theme }) => theme.color.glassBorder}; border-radius: ${({ theme }) => theme.radius.sm}; padding: 0 6px; flex: 0 0 auto; `;

function Inner({ row }: { row: MoreLink }) {
  return (
    <>
      <Lead><MoreIcon svg={row.icon} size={20} /></Lead>
      <Text>
        <Label>{row.label}</Label>
        {row.sub && <Sub>{row.sub}</Sub>}
      </Text>
      {row.soon ? <SoonTag>soon</SoonTag> : <Icon name="chevron-right" size={16} />}
    </>
  );
}

export function MoreRow({ row }: { row: MoreLink }) {
  const toast = useToast();
  if (row.href) {
    return <RowLink to={row.href} $primary={row.primary}><Inner row={row} /></RowLink>;
  }
  return (
    <RowButton type="button" onClick={() => toast(`${row.label}: coming soon`)}>
      <Inner row={row} />
    </RowButton>
  );
}
